import React, { useState } from 'react'
import HeaderEducationAccredited from '../components/Header/EducationGetAccreditedHeader/EducationGetAccreditedHeader'
import PurchaseModal from '../pages/EducationPortal/GetAccredited/PurchaseModal'

const EducationAccreditedLayout = ({ children, setShowPurchaseModal }) => {
    const [showPurchaseModal, setLocalShowPurchaseModal] = useState(false)

    // If setShowPurchaseModal prop is passed (like from HOC), prefer it
    const setter = setShowPurchaseModal || setLocalShowPurchaseModal
    return (
        <div className='educationAccredited-layout'>
            <div className="d-md-block position-sticky top-0 z-index-9">
                <HeaderEducationAccredited setShowPurchaseModal={setter} />
            </div>
            <div className='educationAccredited-main'>
                <div className="educationAccredited-content">{React.cloneElement(children, { setShowPurchaseModal: setter })}</div>
            </div>
            {showPurchaseModal && (
                <PurchaseModal setShowPurchaseModal={setter} />
            )}
        </div>
    )
}

export default EducationAccreditedLayout